export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const CLEAR_USER = "CLEAR_USER";
export const SET_SEARCHED_USER = "SET_SEARCHED_USER";
export const CLEAN_SEARCHED_USER = "CLEAN_SEARCHED_USER";
